import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { UserDefinedDataType } from "@core/enums/user-defined-data-type.enum";
import { UserDefinedFieldPosition } from "@core/enums/user-defined-field-position.enum";
import { UserDefinedField, UserDefinedFieldGroup, UserDefinedFieldPost } from "@core/models/shared/user-defined-field.model";
import { nameof } from "./typescript.helpers";

// build user defined fields array from UserDefinedField GET
export function initUserDefinedFieldsArray(userDefinedFields: UserDefinedField[]): FormArray<FormGroup<UserDefinedFieldGroup>> {
  const formArray = new FormArray<FormGroup<UserDefinedFieldGroup>>([]);
  userDefinedFields?.forEach((field) => {
    let formGroup = new FormGroup<UserDefinedFieldGroup>({
      id: new FormControl<number>(field.id),
      dataType: new FormControl<UserDefinedDataType>(field.dataType),
      position: new FormControl<UserDefinedFieldPosition>(field.position ?? null),
      icon: new FormControl<string>(field.icon ?? null),
      label: new FormControl<string>(field.name),
      tooltip: new FormControl<string>(field.description),
    });
    switch (field.dataType) {
      case UserDefinedDataType.Decimal: {
        formGroup.addControl(
          nameof<UserDefinedFieldGroup>('decimalVal'), 
          new FormControl<number>(field.decimalVal ?? null));
        break;
      }
      case UserDefinedDataType.String: {
        formGroup.addControl(
          nameof<UserDefinedFieldGroup>('stringVal'), 
          new FormControl<string>(field.stringVal ?? null));
        break;
      }
      case UserDefinedDataType.LongString: {
        formGroup.addControl(
          nameof<UserDefinedFieldGroup>('stringVal'), 
          new FormControl<string>(field.stringVal ?? null));
        break;
      }
      case UserDefinedDataType.Date: {
        formGroup.addControl(
          nameof<UserDefinedFieldGroup>('dateVal'), 
          new FormControl<Date>(field.dateVal  ?? null));
        break;
      }
      case UserDefinedDataType.DateTime: {
        formGroup.addControl(
          nameof<UserDefinedFieldGroup>('dateTimeVal'), 
          new FormControl<Date>(field.dateTimeVal ?? null));
        break;
      }
    }
    formArray.push(formGroup);
  });
  return formArray;
}

// build POST DTO from user defined fields array 
export function buildUserDefinedFieldsPost(formArray: FormArray<FormGroup<UserDefinedFieldGroup>>): UserDefinedFieldPost[]{
  const userDefinedFieldsPost: UserDefinedFieldPost[] = formArray.value.map(udf => {
    return {
      id: udf.id,
      decimalVal: udf.dataType === UserDefinedDataType.Decimal ? udf.decimalVal : null,
      stringVal: udf.dataType === UserDefinedDataType.String || udf.dataType === UserDefinedDataType.LongString ? udf.stringVal : null,
      dateVal: udf.dataType === UserDefinedDataType.Date ? udf.dateVal : null,
      dateTimeVal: udf.dataType === UserDefinedDataType.DateTime ? udf.dateTimeVal : null,
    }
  });
  return userDefinedFieldsPost;
}

// take the form array and organize it into arrays of form groups based off position (form form placement)
export function positionUserDefinedFields(
  formArray: FormArray<FormGroup<UserDefinedFieldGroup>>, 
  position: UserDefinedFieldPosition,
  isDefaultPosition: boolean = false): FormGroup<UserDefinedFieldGroup>[] {
  return formArray.controls.filter(fg => 
    (fg.controls.position.value == null && isDefaultPosition)
    || fg.controls.position.value === position);
}
